/* Nio: show the crossed-out "compare at" price in the Loop Subscriptions widget (Nov 2026).
   - One-time option: un-hides Loop's own compare-at element (variant compare_at_price).
   - Subscription options: replaces the crossed-out one-time price with the same compare-at price.
   Uses the text Loop already formatted, so currency conversion stays correct.
   Re-applies whenever Loop re-renders (variant change, option change). */
(function () {
  var CMP = '.loop-w-btn-group-purchase-option-compare-at-price';
  var PRICE = '.loop-w-btn-group-purchase-option-price';

  function num(t) {
    t = (t || '').replace(/[^\d.,]/g, '');
    if (!t) return NaN;
    var m = t.match(/[.,](\d{1,2})$/);
    var whole = m ? t.slice(0, -m[0].length) : t;
    return parseFloat(whole.replace(/[.,]/g, '') + '.' + (m ? m[1] : '0'));
  }

  function apply(widget) {
    var one = widget.querySelector('.loop-w-btn-group-purchase-option-onetime');
    if (!one) return;
    var oneCmp = one.querySelector(CMP);
    var onePrice = one.querySelector(PRICE);
    if (!oneCmp || !onePrice) return;
    var cmpText = oneCmp.textContent.trim();
    var hasCmp = num(cmpText) > num(onePrice.textContent);
    oneCmp.classList.toggle('nio-loop-compare', hasCmp);
    if (!hasCmp) return;
    widget.querySelectorAll('[data-loop-widget-selling-plan-group] ' + CMP).forEach(function (el) {
      if (el.textContent.trim() !== cmpText) el.textContent = cmpText;
    });
  }

  function run() {
    document.querySelectorAll('.loop-widget-container').forEach(apply);
  }

  var style = document.createElement('style');
  style.textContent =
    '.loop-widget-container ' + CMP + '.nio-loop-compare{display:block!important}' +
    '.loop-widget-container ' + CMP + '{order:-1}'; /* old price before the new price */
  document.head.appendChild(style);

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; run(); });
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  run();
})();
